import {TimelineEntry} from './TimelineEntry';

export class TimelineDisconnectedEntry extends TimelineEntry {

    constructor(public key: string, public startDate: Date) {
        super(key, 'Disconnected', startDate, true);
    }

    getColor(): string {
        return '#E64337';
    }

}
